// Tastenbelegung nach `KeyboardEvent.code`, also nach physischer Lage: `KeyW` ist die Taste
// links oben im Buchstabenblock, auf deutscher wie auf englischer Tastatur. Die Interaktionstaste
// steht nicht hier; sie kommt je Tick aus der verfügbaren Handlung (docs/architektur.md).

export const KEYS = {
  forward: 'KeyW',
  back: 'KeyS',
  left: 'KeyA',
  right: 'KeyD',
  /** Springen, beim Fliegen aufwärts. */
  jump: 'Space',
  /** Beim Fliegen abwärts. */
  down: 'ShiftLeft',
  /** Fliegen ein- und ausschalten (Flanke). */
  fly: 'KeyF',
  /**
   * Zwischen Ego-Sicht und Schulterkamera wechseln (Flanke). Sie steht hier bei den Spieltasten,
   * damit der Browser sie nicht anders belegt – sie erzeugt aber keine Absicht: Welche Kamera
   * zeigt, ist Ansicht und kein Spielzustand (Architektur-Regel 1).
   */
  sicht: 'KeyV',
  /**
   * Anwesenheitsliste zeigen, solange gehalten (task-016). Als Spieltaste unterdrückt der Client mit
   * gefangener Maus den Sprung zum nächsten Element; mit freier Maus bleibt Tab die Taste für Knöpfe.
   */
  liste: 'Tab',
  /** Das Satz-Menü öffnen (Flanke, task-016). Wie V keine Absicht: Welches Menü offen ist, ist Ansicht. */
  saetze: 'KeyT',
} as const;

/** Alle belegten Tasten; für sie unterdrückt der Client die Browser-Vorgabe (z. B. Scrollen). */
export const GAME_KEYS: ReadonlySet<string> = new Set(Object.values(KEYS));

const LABELS: Record<string, string> = {
  Space: 'Leertaste',
  ShiftLeft: 'Umschalt',
  ShiftRight: 'Umschalt',
  Escape: 'Esc',
};

/** Lesbarer Name einer Taste für Anzeigen, z. B. `KeyE` → `E`, `Space` → `Leertaste`. */
export function keyLabel(code: string): string {
  const bekannt = LABELS[code];
  if (bekannt !== undefined) return bekannt;
  if (code.startsWith('Key')) return code.slice(3);
  if (code.startsWith('Digit')) return code.slice(5);
  return code;
}
